/* eslint-disable sort-keys */
import { NodeSchemaProperties, NodeUiSchemaProperties } from '../../../@types/NodeSchemaProperties';

export const mobileV3LocalizationConciergeSchema: NodeSchemaProperties = {
  concierge: {
    title: '#29 Concierge',
    type: 'object',
    properties: {
      'title:enable': {
        description: '[concierge.title]',
        title: '#1 Title',
        type: 'boolean',
      },
      title: {
        type: 'string',
      },
      'closeButton:enable': {
        description: '[concierge.closeButton]',
        title: '#2 Close button title',
        type: 'boolean',
      },
      closeButton: {
        type: 'string',
      },
      'moreInfoButton:enable': {
        description: '[concierge.moreInfoButton]',
        title: '#3 More info button',
        type: 'boolean',
      },
      moreInfoButton: {
        type: 'string',
      },
    },
  },
};

export const mobileV3LocalizationConciergeUiSchema: NodeUiSchemaProperties = {
  concierge: {
    title: {
      'ui:label': false,
      'ui:readonly': true,
    },
    closeButton: {
      'ui:label': false,
      'ui:readonly': true,
    },
    moreInfoButton: {
      'ui:label': false,
      'ui:readonly': true,
    },
  },
};
